<template>
  <div class="dropdown-menu" role="menu">
    <div class="dropdown-content has-text-left">
      <div class="columns is-multiline w360p is-gapless is-padding-xsmall">
        <div class="column is-padding-left-xsmall is-padding-right-xsmall is-padding-bottom-xsmall is-6 control dropdown-item"
             v-for="(c, i) in entries" :key="i"
             @click="onChange(c.key)">
             <div>
              <span class="icon has-text-dark">
                <i v-if="isChecked(c.key)" class="fal fa-lg fa-check-circle"></i>
                <i v-else class="fal fa-lg fa-circle"></i>
              </span>
              <span :class="isChecked(c.key) ? 'has-text-dark' : 'has-text-grey'" class="is-marginless">{{ c.label }}</span>
            </div>
          <!-- <input :id="'columnref' + c.key" type="checkbox" name="column" class="is-checkradio is-circle is-small"
                 :value="c.key" v-model="columns">
              <label class="is-wrap-normal is-marginless" :for="'columnref' + c.key">{{ c.label }}</label> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { bus, EVENTS } from '@/services/bus/index.js'
  export default {
    name: 'ColumnsToggles',
    props: {
      source: {
        type: Array,
        required: true
      },
      entries: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        columns: []
      }
    },
    methods: {
      isChecked (val) {
        let check = this.columns.find(x => x === val)
        if (check) return true
        else return false
      },
      onChange (val) {
        let index = this.columns.findIndex(x => x === val)
        if (index !== -1) {
          this.columns.splice(index, 1)
        } else {
          this.columns.push(val)
        }
        this.$nextTick(() => {
          this.$emit('commit')
          this.$emit('update', this.columns)
          bus.$emit(EVENTS.RESIZE_TABLE)
        })
      }
    },
    created () {
      this.columns = this.source.slice()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/utils/ColumnsToggles.vue